import "core-js/modules/es.number.constructor.js";
import { ref, onMounted, reactive, defineComponent, defineEmits, watch } from 'vue';
export default defineComponent({
  components: {},
  name: 'MiniPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 5
    },
    currentPage: {
      type: Number,
      default: 1
    },
    continues: {
      type: Number,
      default: 5
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var currentPage = ref(props.currentPage);
    watch(function () {
      return props.currentPage;
    }, function (newVal) {
      currentPage.value = newVal;
    });

    var handleCurrentChange = function handleCurrentChange(val) {
      currentPage.value = val;
      emit('page-changed', val);
    };

    return {
      currentPage: currentPage,
      handleCurrentChange: handleCurrentChange
    };
  }
});